/**
 * 与dom相关的util方法
 */
function isSupportWebp() {
  try {
    return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0
  } catch (err) {
    return false
  }
}

function isSupportPassive() {
  var passiveSupported = false
  try {
    var options = Object.defineProperty({}, 'passive', {
      get: () => {
        passiveSupported = true
      }
    })
    window.addEventListener('passiveSupported', null, options)
  } catch (error) {
    passiveSupported = false
  }
  return passiveSupported
}

function remoteLoad(url, hasCallback) {
  return createScript(url)

  /**
   * 创建script
   * @param url
   * @returns {Promise}
   */
  function createScript(url) {
    var scriptElement = document.createElement('script')
    document.body.appendChild(scriptElement)
    var promise = new Promise((resolve, reject) => {
      scriptElement.addEventListener(
        'load',
        e => {
          removeScript(scriptElement)
          if (!hasCallback) {
            resolve(e)
          }
        },
        false
      )

      scriptElement.addEventListener(
        'error',
        e => {
          removeScript(scriptElement)
          reject(e)
        },
        false
      )

      if (hasCallback) {
        window.____callback____ = function () {
          resolve()
          window.____callback____ = null
        }
      }
    })

    if (hasCallback) {
      url += '&callback=____callback____'
    }

    scriptElement.src = url

    return promise
  }

  /**
   * 移除script标签
   * @param scriptElement script dom
   */
  function removeScript(scriptElement) {
    document.body.removeChild(scriptElement)
  }
}

function asyncLoadJs(url) {
  return new Promise((resolve, reject) => {
    let hasLoaded = document.querySelectorAll('script[src="' + url + '"]').length > 0
    if (hasLoaded) {
      resolve()
      return
    }

    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    document.body.appendChild(script)
    script.onload = () => {
      resolve()
    }
    script.onerror = () => {
      reject()
    }
  })
}

/* eslint-disable */
function vivoMove(t, e) {
  var n = {
      edge: !0
    },
    i = {}
  e = e || {}
  for (var a in n) {
    typeof e[a] != 'undefined' ? (i[a] = e[a]) : (i[a] = n[a])
  }
  var o = {
      distanceX: 0,
      distanceY: 0
    },
    r = window,
    c = document.documentElement,
    d = c.clientWidth,
    s = c.clientHeight
  if (t) {
    var ele = t
    var c = function (e, n) {
        ;(e = Math.round(1e3 * e) / 1e3),
          (n = Math.round(1e3 * n) / 1e3),
          (t.style.webkitTransform = 'translate(' + [e + 'px', n + 'px'].join(',') + ')'),
          (t.style.transform = 'translate3d(' + [e + 'px', n + 'px', 0].join(',') + ')')
      },
      u = (function () {
        var t = ele
        return t.id && localStorage && localStorage['ShopVivo_' + t.id] ? localStorage['ShopVivo_' + t.id] : ''
      })()
    if (u) {
      var g = u.split(',')
      ;(t.distanceX = +g[0]), (t.distanceY = +g[1]), c(t.distanceX, t.distanceY)
    }
    t.style.visibility = 'visible'
    var h = t.getBoundingClientRect()
    ;(h.left < -0.5 * h.width ||
      h.top < -0.5 * h.height ||
      h.right > d + 0.5 * h.width ||
      h.bottom > s + 0.5 * h.height) &&
      ((t.distanceX = 0), (t.distanceY = 0), c(0, 0)),
      t.addEventListener('touchstart', function (e) {
        // if (Utils.isVivoApp()) {
        //   var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        //   scrollTop <= 0 && window.scrollTo(0, 5) // 向上滚一点避免与下拉刷新冲突；window.vivospace.enablePullRefresh('false')无效
        // }
        var n = e.touches[0] || e
        ;(o.posX = n.pageX),
          (o.posY = n.pageY),
          (o.touching = !0),
          t.distanceX && (o.distanceX = t.distanceX),
          t.distanceY && (o.distanceY = t.distanceY),
          (o.bound = t.getBoundingClientRect()),
          (o.timerready = !0)
      }),
      t.addEventListener(
        'touchmove',
        function (e) {
          e.preventDefault()
        },
        {
          passive: false
        }
      )
    var f = function (t, e, n, i) {
      return (t /= i) < 1 / 2.75
        ? 7.5625 * n * t * t + e
        : t < 2 / 2.75
        ? n * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + e
        : t < 2.5 / 2.75
        ? n * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + e
        : n * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + e
    }
    document.addEventListener(
      'touchmove',
      function (e) {
        if (!0 === o.touching) {
          o.timerready == 1 && ((o.timerstart = +new Date()), (o.timerready = !1)), e.preventDefault()
          var n = e.touches[0] || e
          ;(o.nowX = n.pageX), (o.nowY = n.pageY)
          var i = o.nowX - o.posX,
            a = o.nowY - o.posY,
            r = o.bound.left + i,
            u = o.bound.top + a,
            g = r + o.bound.width,
            h = u + o.bound.height
          r < 0 && (i -= r), u < 0 && (a -= u), g > d && (i -= g - d), h > s && (a -= h - s)
          var f = o.distanceX + i,
            l = o.distanceY + a
          c(f, l), (t.distanceX = f), (t.distanceY = l)
        }
      },
      {
        passive: false
      }
    ),
      document.addEventListener('touchend', function () {
        if (!1 !== o.touching && ((o.touching = !1), (o.timerend = +new Date()), o.nowX && o.nowY)) {
          var e = o.nowX - o.posX,
            n = o.nowY - o.posY
          if (!(Math.abs(e) < 5 && Math.abs(n) < 5)) {
            var a = Math.sqrt(e * e + n * n),
              u = o.timerend - o.timerstart,
              g = (a / u) * 16.666,
              h = Math.min(10, g)
            o.inertiaing = !0
            var l = 1,
              v = 1,
              m = function () {
                if (o.touching != 1) {
                  var u = (l * (g -= g / h) * e) / a,
                    f = (v * g * n) / a,
                    X = t.getBoundingClientRect()
                  u < 0 && X.left + u < 0
                    ? ((u = 0 - X.left), (l *= -1))
                    : u > 0 && X.right + u > d && ((u = d - X.right), (l *= -1)),
                    f < 0 && X.top + f < 0
                      ? ((f = -1 * X.top), (v *= -1))
                      : f > 0 && X.bottom + f > s && ((f = s - X.bottom), (v *= -1))
                  var Y = t.distanceX + u,
                    w = t.distanceY + f
                  c(Y, w),
                    (t.distanceX = Y),
                    (t.distanceY = w),
                    g < 0.1
                      ? ((g = 0),
                        i.edge == 0
                          ? ((o.inertiaing = !1), r.localStorage && (localStorage['ShopVivo_' + t.id] = [Y, w].join()))
                          : p())
                      : requestAnimationFrame(m)
                } else {
                  o.inertiaing = !1
                }
              },
              p = function () {
                var e = 0,
                  n = t.distanceX,
                  i = t.distanceY,
                  a = 0,
                  s = t.getBoundingClientRect()
                a = s.left + s.width / 2 < d / 2 ? -1 * s.left : d - s.right
                var u = function () {
                  if (o.touching != 1) {
                    var d = f(++e, n, a, 25)
                    c(d, i),
                      e < 25
                        ? requestAnimationFrame(u)
                        : ((t.distanceX = d),
                          (t.distanceY = i),
                          (o.inertiaing = !1),
                          r.localStorage && (localStorage['ShopVivo_' + t.id] = [d, i].join()))
                  } else {
                    o.inertiaing = !1
                  }
                }
                u()
              }
            m()
          }
        }
      })
  }
}
/* eslint-enable */
export { isSupportWebp, isSupportPassive, remoteLoad, vivoMove, asyncLoadJs }
